module.exports = __webpack_public_path__ + "img/giving.f9d584b4.svg";